"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataCy = void 0;
const onboardingExampleDocuments_1 = require("./onboardingExampleDocuments");
/**
 * These values are shared between two places, so we can cross-reference usages:
 *  - The Cypress tests in packages/cypress
 *  - The application frontend components, in attributes like data-cy={googleSignInSubmit}
 *    - See https://docs.cypress.io/guides/references/best-practices#Selecting-Elements
 */
exports.dataCy = {
    // Sign In
    googleSignInSubmit: "googleSignInSubmit",
    forgotPassword: "forgotPassword",
    githubSignInSubmit: "githubSignInSubmit",
    // Sign Up
    signUp: {
        onboardingExampleCount: onboardingExampleDocuments_1.ONBOARDING_CURRENT_DOCUMENT_DETAILS.length,
        chooseHardwareButton: "chooseHardwareButton",
    },
    // Reset Password Flow
    resetPassword: {
        forgotPasswordTitle: "forgotPasswordTitle",
        createNewPasswordTitle: "createNewPasswordTitle",
    },
    actionsMenu: {
        archiveDocument: "archiveDocument",
        buttonId: "#nav-action-menu-button",
        importForUser: "importForUser",
        importForEnterprise: "importForEnterprise",
        importForOrganization: "importForOrganization",
        createNewProjectForUser: "createNewProjectForUser",
        createNewProjectForEnterprise: "createNewProjectForEnterprise",
        createNewProjectForOrganization: "createNewProjectForOrganization",
        cloneDocument: "cloneDocument",
        cloneDocumentToUserInList: "cloneDocumentToUserInList",
        cloneDocumentToEnterpriseInList: "cloneDocumentToEnterpriseInList",
        cloneDocumentToOrganizationInList: "cloneDocumentToOrganizationInList",
        deleteDocument: "deleteDocument",
        forkDocument: "forkDocument",
        forkDocumentToUserInList: "forkDocumentToUserInList",
        forkDocumentToEnterpriseInList: "forkDocumentToEnterpriseInList",
        forkDocumentToOrganizationInList: "forkDocumentToOrganizationInList",
    },
    onboarding: {
        dialog: "onboardingDialog",
        steps: {
            survey: "onboardingDialogSurvey",
            chooseInvites: "onboardingDialogChooseInvites",
            choosePlan: "onboardingDialogChoosePlan",
        },
    },
    organizations: {
        createDialog: "createDialog",
        createDialogHandleInput: "createDialogHandleInput",
        createDialogDisplayNameInput: "createDialogDisplayNameInput",
        addMembersDialog: "addMembersDialog",
        addMembersDialogAutocompleteInput: "addMembersDialogAutocompleteInput",
    },
    paywall: {
        continueButton: "paywallContinueButton",
        ownerSelector: "paywallOwnerSelector",
    },
    // Profile
    profileStarredTab: "profileStarredTab",
    profileOverviewTab: "profileOverviewTab",
    profileMembersTab: "profileMembersTab",
    profileSettingsTab: "profileSettingsTab",
    profileOrganizationSettingsPanel: "profileOrganizationSettingsPanel",
    profileDocumentCard: "profileDocumentCard",
    profileExampleCard: "profileExampleCard",
    profileMemberCard: "profileMemberCard",
    profileMemberCardRole: "profileMemberCardRole",
    profileFullNameHeader: "profileFullNameHeader",
    profileHandleHeader: "profileHandleHeader",
    descriptionHeader: "descriptionHeader",
    websiteHeader: "WebsiteHeader",
    twitterHeader: "TwitterusernameHeader",
    githubHeader: "GithubusernameHeader",
    editProfileButton: "editProfileButton",
    fullNameField: "fullNameField",
    bioField: "bioField",
    websiteField: "WebsiteField",
    twitterUsernameField: "TwitterusernameField",
    githubUsernameField: "GithubusernameField",
    doneButton: "doneButton",
    newProjectButton: "newProjectButton",
    addMembersButton: "addMembersButton",
    removeMemberMenuAction: "removeMemberMenuAction",
    longMenu: "longMenu",
    deleteButton: "deleteButton",
    deletePermanentlyConfirmationButton: "DeletePermanentlyButton",
    starButton: "starButton",
    unstarButton: "unstarButton",
    // Schematic
    partSearchResultListItem: "partSearchResultListItem",
    partSearchClearButton: "partSearchClearButton",
    // Pcb - AddNodeMenuItem
    addNodeNestedMenu: "addNodeNestedMenu",
    layoutNodeMenuItem: "layoutNodeMenuItem",
    padNodeMenuItem: "padNodeMenuItem",
    footprintNodeMenuItem: "footprintNodeMenuItem",
    // Pcb - Canvas Overlay
    toggleLayerViewController: "toggleLayerViewController",
    menuLayerViewController: "menuLayerViewController",
    showLayerButton: "showLayerButton",
    showFillButton: "showFillButton",
    hideLayerButton: "hideLayerButton",
    hideFillButton: "hideFillButton",
    flipCameraButton: "flipCameraButton",
    show3dButton: "show3dButton",
    show2dButton: "show2dButton",
    showTopCameraButton: "showTopCameraButton",
    showBottomCameraButton: "showBottomCameraButton",
    // Pcb - Left Drawer
    libraryTab: "libraryTab",
    objectsTab: "objectsTab",
    rulesTab: "rulesTab",
    pcbObjectsSearch: "objectsSearch",
    // Pcb - Right Drawer
    inspectorTab: "inspectorTab",
    newInspectorTab: "newInspectorTab",
    copilotChatTab: "copilotChatTab",
    copilotChatThread: {
        scrollContainer: "copilotChatThreadScrollContainer",
        message: "copilotChatThreadMessage",
    },
    reviewTab: "reviewTab",
    ruleActive: "ruleActive",
    objectSpecificRules: "objectSpecificRules",
    // Shared canvas controls
    zoomToFitButton: "zoomToFitButton",
    zoomToActualSizeButton: "zoomToActualSizeButton",
    calibrateScreenDpiButton: "calibrateScreenDpiButton",
    showGridButton: "showGridButton",
    leftPaneExpandButton: "left-pane-expand-button",
    rightPaneExpandButton: "right-pane-expand-button",
    // Share dialog
    shareDialog: {
        shareButton: "shareButton",
        doneButton: "shareDialogDoneButton",
        showAdvancedPermissionsFormButton: "showAdvancedPermissionsFormButton",
        simplePermissionsForm: "simplePermissionsForm",
        advancedPermissions: {
            form: "advancedPermissionsForm",
            inviteAutocomplete: "advancedPermissionsInviteAutocomplete",
            inviteAddButton: "advancedPermissionsInviteAddButton",
            invitePermissionSelect: "advancedPermissionsInvitePermissionSelect",
        },
    },
    // Top menu bar
    schematicToggle: "schematic-toggle",
    codeToggle: "code-toggle",
    pcbToggle: "pcb-toggle",
    starProjectButton: "starProjectButton",
    starProjectCountText: "starProjectCountText",
    forkProjectButton: "forkProjectButton",
    forkProjectCountText: "forkProjectCountText",
    manufactureProjectButton: "manufactureProjectButton",
    manufacturePriceButton: "manufacturePriceButton",
    accountMenu: {
        buttonId: "#nav-account-menu-button",
    },
    // Shared editor elements
    leftDrawer: "leftDrawer",
    rightDrawer: "rightDrawer",
    changeHistoryResultsListContainer: "changeHistoryResultsListContainer",
    backButtonNavBar: "backButtonNavBar",
    partPublishDialog: "partPublishDialog",
    partUpdatesDialog: "partUpdatesDialog",
    navigationControlsDialog: "navigationControlsDialog",
    keyboardShortcutsDialog: "keyboardShortcutsDialog",
    objectTreeItem: "objectTreeItem",
    objectTreeItemExpandToggle: "objectTreeItemExpandToggle",
    // Comments
    commentInput: "commentInput",
    commentReplyInput: "replyInput",
    commentReplyButton: "replyButton",
    commentMoreMenuButton: "moreMenuButton",
    commentDelete: "commentDelete",
    commentDeleteReply: "commentDeleteReply",
    commentContainer: "commentContainer",
    commentThread: "commentThread",
    // Page elements
    navBar: "navBar",
    navActionMenuButton: "#nav-action-menu-button",
    navBarProjectName: "navBarProjectName",
    createNewProjectMenuButton: "createNewProjectMenuButton",
    createNewBlankProjectButton: "createNewBlankProjectButton",
    createNewProjectMenuFromTemplateButton: "createNewProjectMenuFromTemplateButton",
    diagramRootElement: "diagramRootElement",
    userPresenceElement: "userPresenceElement",
    searchResultItem: "searchResultItem",
    editorModeToggle: (mode) => `${mode}-toggle`,
    // Marketing page (for redirect testing only)
    marketingPage: "marketing-page",
};
//# sourceMappingURL=cy.js.map